import { fetchData } from "../../../../product/newUI/services/fetchData";

export const getAuditTrails = (payload) => {
	return fetchData("quosalweb/quosalapi/Quote.AuditTrail", "Quote.AuditTrail", payload);
};